module.exports = __webpack_public_path__ + "img/CRC1_NK.e3272327.png";